module.exports = __webpack_public_path__ + "static/img/rank_241.d3fd0d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_241.png
// module id = z7Ow
// module chunks = 1